<span [ngSwitch]="status">
  <span class="badge-status primary" *ngSwitchCase="'Open'">
    {{status}}
  </span>
  <span class="badge-status white" *ngSwitchCase="'New'">
    {{status}}
  </span>
  <span class="badge-status white" *ngSwitchCase="'Not Started'">
    {{status}}
  </span>
  <span class="badge-status success" *ngSwitchCase="'Received'">
    {{status}}
  </span>
  <span class="badge-status primary-2" *ngSwitchCase="'Assigned'">
    {{status}}
  </span>
  <span class="badge-status primary-2" *ngSwitchCase="'Allocated'">
    {{status}}
  </span>
  <span class="badge-status primary" *ngSwitchCase="'Deallocated'">
    {{status}}
  </span>
  <span class="badge-status red" *ngSwitchCase="'Canceled By Customer'">
    {{status}}
  </span>
  <span class="badge-status danger" *ngSwitchCase="'Closed'">
    {{status}}
  </span>
  <span class="badge-status danger" *ngSwitchCase="'Pending'">
    {{status}}
  </span>
  <span class="badge-status success" *ngSwitchCase="'Active'">
    {{status}}
  </span>
  <!-- <span class="badge-status primary" *ngSwitchCase="'Pending'">
    {{status}}
  </span> -->
  <span class="badge-status success" *ngSwitchCase="'Fully Picked'">
    {{status}}
  </span>
  <span class="badge-status success" *ngSwitchCase="'Yes'">
    {{status}}
  </span>
  <span class="badge-status danger" *ngSwitchCase="'No'">
    {{status}}
  </span>
  <span class="badge-status white" *ngSwitchDefault>
    {{status}}
  </span>
</span>